<template>
  <div id="profile" class="container">
    <!-- {{userData}} -->
    <!-- <div class="row">
      <div class="col">
      </div>
    </div> -->
  <div class="container py-4">

    <div class="row justify-content-center mb-3">
      <div class="col-md-4">
        <div class="h-100 p-5 text-white bg-dark rounded-3 m-auto">
          <div class="row justify-content-center mb-2">
          <img :src="userData.imageUrl ? userData.imageUrl : 'https://westsiderc.org/wp-content/uploads/2019/08/Image-Not-Available.png'" alt="Profile Image" class="image-thumbnail" id="profileImg">
          </div>
          Username<h2>{{userData.username}}</h2>
          <p>Email<p><h2>{{userData.email}}</h2>
        </div>
      </div>
        <div class="p-5 bg-light rounded-3 col py-auto">
      <div class="container-fluid py-0 my-0">
        <h1 class="display-5 fw-bold">My Decks</h1>
        <div class="card bg-secondary text-white">
            <div class="row py-4">
            <div class="col-sm-3">
              Title
            </div>
            <div class="col-sm-2">
              Total Deck
            </div>
            <div class="col-sm-2">
              Total Price
            </div>
            <div class="col-sm">
              QR Code
            </div>
            </div>
        </div>
        <div v-for="deck in userData.Decks" :key="deck.id" class="container mx-0 px-0">
          <div class="card">
            <div class="row py-4">
            <div class="col-sm-3">
              {{deck.name}}
            </div>
            <div class="col-sm-2">
              {{deck.total}}
            </div>
            <div class="col-sm-2">
              $ {{deck.totalPrice}}
            </div>
            <div class="col-sm">
              <img :src="deck.qrCode" alt="QR Code" srcset="">
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
    </div>


</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  },
  computed: {
    userData () {
      return this.$store.state.userData
    }
  },
  created () {
    this.$store.dispatch('fetchProfile')
  }
}
</script>

<style scoped>
#profileImg {
  max-width: 200px;
}
</style>